import { render } from "./Edit_1.vue?vue&type=template&id=3e88c24a&scoped=true"
import script from "./Edit_1.vue?vue&type=script&lang=js"
export * from "./Edit_1.vue?vue&type=script&lang=js"

import "./Edit_1.vue?vue&type=style&index=0&id=3e88c24a&scoped=true&lang=css"

import exportComponent from "B:\\GitHub\\Nakronpao\\Nakronpao-health\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e88c24a"]])

export default __exports__